import Vue from "vue"

export default {
    updateIntegration(state, integrationData) {
        const id = integrationData.id
        if(integrationData.emrs.length === 0)
            return
        const intData = integrationData.emrs[0]
        if(intData.combined_notes) {
            if(state.record.schedule && state.record.schedule[id] && Array.isArray(state.record.schedule[id])) {
                let scheduleDataIndex = state.record.schedule[id].findIndex((schedule) => schedule.id === integrationData.schedule)
                if(scheduleDataIndex >= 0) {
                    let scheduleData = state.record.schedule[id][scheduleDataIndex]
                    if(!scheduleData.integration)
                        scheduleData.integration = { combined_notes_push_to_emr: {} }
                        scheduleData.integration.combined_notes_push_to_emr[intData.emr_category] = {last_pushed : new Date()}
                    Vue.set(state.record.schedule[id], scheduleDataIndex, scheduleData)
                }
            }
        }
        else if(intData.questionnaire_notes) {
            if(state.record.event && state.record.event[id] && Array.isArray(state.record.event[id])) {
                Object.keys(intData.questionnaire_notes).forEach((eventId) => {
                    let eventDataIndex = state.record.event[id].findIndex((event) => event.id === eventId)
                    if(eventDataIndex >= 0) {
                        let eventData = state.record.event[id][eventDataIndex]
                        if(!eventData.integration)
                            eventData.integration = { push_to_emr: {} }
                            eventData.integration.push_to_emr[intData.emr_category] = {last_pushed: new Date()}
                        Vue.set(state.record.event[id], eventDataIndex, eventData)
                    }
                })
                
            }
        }
    },
    addTicketsNew(state, response) {
        const providerIndex = state.tickets.findIndex(
            (provider) => provider.id === response.id
        )
        if (providerIndex !== -1) {
            const newTickets = [...state.tickets[providerIndex].tickets, ...response.tickets]
            Vue.set(state.tickets, providerIndex, { id: response.id, tickets: newTickets})
        }
        else
            state.tickets.push(response)
      }
}